<template>
  <div>
    <breadcrumb :list='breadcrumbList'></breadcrumb>
    <el-card class='main'>
      <el-form ref='searchEmp' :model='searchEmp'>
        <el-row>
          <!-- <el-col :xs="24" :sm="12" :md="6" :lg="4.1">
            <el-form-item label-width="70px">
              <div slot="label">管理机构</div>
              <el-select v-model="searchEmp.gljg" placeholder="请选择">
                <el-option v-for="item in gljgList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :xs='24' :sm='12' :md='6' :lg='4.1'>
            <el-form-item label-width='70px'>
              <div slot='label'>姓名</div>
              <el-input size='medium' v-model.trim='searchEmp.cyry_xm' clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs='24' :sm='12' :md='6' :lg='4.1'>
            <el-form-item label-width='70px'>
              <div slot='label'>手机号</div>
              <el-input size='medium' v-model='searchEmp.cyry_lxdh' clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs='24' :sm='12' :md='6' :lg='4.1'>
            <el-form-item label-width='70px'>
              <div slot='label'>性别</div>
              <el-select v-model='searchEmp.cyry_xb' placeholder='请选择'>
                <el-option v-for='item in xbList' :key='item.code' :label='item.title' :value='item.code'>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs='24' :sm='12' :md='6' :lg='4.1'>
            <el-form-item label-width='70px'>
              <div slot='label'>身份证号</div>
              <el-input size='medium' v-model='searchEmp.cyry_zjhm' clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs='24' :sm='12' :md='12' :lg='12' style='float:right'>
            <el-row style='text-align:end;width:100%'>
              <el-button type='success' @click='add'> 新增</el-button>
              <el-button type='info' @click='clean_btn'>重置</el-button>
              <el-button type='primary' @click='search_btn'>查询</el-button>
            </el-row>
          </el-col>
        </el-row>


      </el-form>
      <Total :total='total'></Total>
      <el-table :data='tableData' style='width: 100%;' :header-cell-style="{ background: '#F1F2F7', color: '#606266' }"
                @cell-click='cellClick'>
        <el-table-column prop='cyry_bm' label='人员编号' min-width='160px' align='center'>
        </el-table-column>
        <el-table-column prop='cyry_xm' label='姓名' min-width='100px' align='center'>
        </el-table-column>
        <el-table-column prop='cyry_rylbdm' label='人员类别' min-width='200px' align='center'
                         :formatter='rylbFormatter'>
        </el-table-column>
        <el-table-column prop='cyry_xb' label='性别' align='center' :formatter='xbFormatter'>
        </el-table-column>
        <el-table-column prop='cyry_lxdh' label='联系电话' min-width='130px' align='center'>
        </el-table-column>
        <el-table-column prop='cyry_cyztdm' label='人员状态' min-width='100px' align='center'
                         :formatter='ryztFormatter'>
        </el-table-column>
        <el-table-column prop='create_time' label='创建日期' align='center' min-width='170px'>
        </el-table-column>
        <el-table-column label='操作' align='center' min-width='160px' fixed='right'>
          <template slot-scope='scope'>
            <el-button size='mini' type='warning' plain @click.stop='handleEdit(scope.row)'>修改</el-button>
            <el-button size='mini' type='danger' plain @click.stop='handleDelete(scope.row)'>删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->

      <div class='page'>
        <el-pagination v-if='tableData.length != 0' class='fy' layout='prev, pager, next' :total='total'
                       :page-size='pageData.page_size' :current-page='pageData.page_no' @current-change='current_change'
                       background>
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import Total from '@/components/total/index.vue'
import * as user from '@/api/user.js'
import { filtersInfo, lists } from '@/utils/dictionary.js'

export default {
  name: 'EmployeesIndex',
  data() {
    return {
      breadcrumbList: [
        { name: '从业人员', path: 'employees' }
      ],
      searchEmp: {},
      tableData: [],
      total: 0,
      pageData: {
        // count: null, //总数
        page_no: 1,  //现在
        page_size: 10 //每页条数
        // page:25 //总页数
      },
      // 字典
      gljgList: [],//管理机构
      rylbList: [],
      ryztList: [],
      xbList: [],
      loading: true
    }
  },
  created() {
    this.info()
  },
  methods: {
    async info() {
      const res = await user.getEmployees({ ...this.pageData, ...this.searchEmp })
      this.total = res.total_result
      this.pageData.page_no = res.page_no
      this.pageData.page_size = res.page_size
      this.tableData = res.items
      // 获取字典
      this.getZiDian()


    },
    add() { // 新增
      this.$router.push('/employees/add_employees')
      // 清除缓存
      this.$store.commit('setKeep', '')
    },
    search_btn() { // 查询
      // 当前页强制转为1
      this.pageData.page_no = 1
      this.info()
    },
    clean_btn() { // 重置
      this.searchEmp = {}
      this.info()
    },
    handleEdit({ id }) { // 修改
      this.$router.push({
        path: '/employees/add_employees',
        query: { id }
      })
    },
    async handleDelete({ id }) { //删除
      console.log(id)
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true
        await user.delEmp(id)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.info()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    current_change(val) { //分页功能
      this.pageData.page_no = val
      this.info()
    },
    cellClick({ id }) { //点击单元格,跳转详情
      this.$router.push({
        path: '/employees/employees_details',
        query: { id }
      })
    },
    getZiDian() { //获取字典
      // this.rylbList = lists['RYLB']
      user.getrylb().then(res=>{
        this.rylbList = res
      })
      this.ryztList = lists['RYZT']
      this.xbList = lists['XB']
    },
    xbFormatter(row, column, cellValue) {//格式化性别
      if (cellValue != 0 && !cellValue) return ''
      return filtersInfo(this.xbList, cellValue)
    },
    rylbFormatter(row, column, cellValue) { //格式化人员类别
      if (cellValue != 0 && !cellValue) return ''
      return filtersInfo(this.rylbList, cellValue)
    },
    ryztFormatter(row, column, cellValue) { //格式化人员状态
      if (cellValue != 0 && !cellValue) return ''
      return filtersInfo(this.ryztList, cellValue)
    }
  },
  components: { Total },
  beforeRouteLeave(to, from, next) {
    //离开页面如果去的详情 || 修改 则缓存当前页面
    if (to.path === '/employees/employees_details' ||
      to.path === '/employees/add_employees') {
      this.$store.commit('setKeep', 'EmployeesIndex')
      next()
    } else {
      this.$store.commit('setKeep', '')
      next()
    }
    next()
  }
}
</script>

<style lang='less' scoped>
.main {
  margin: 20px;
  padding: 20px 20px;

  /deep/ .el-form-item {
    margin-right: 20px;
  }

  /deep/ .el-form-item__content {
    height: 50px;
  }

  /deep/ .el-select {
    width: 100%;
  }

  /deep/ thead {
    background-color: #F1F2F7;
    // z-index: 999;
  }

  /deep/ .el-table__row {
    .el-button {
      width: 60px;
      height: 32px;
      // opacity: 0.1;
      border-radius: 16px;
    }
  }
}
</style>